import findIndex from 'lodash/findIndex';

import type { DrawerQueryVariables } from '@virtuslab/nfs-shared/src/schema/user';
import type { Drawer, FlatDrawers } from '@virtuslab/nfs-shared/src/schema/user/drawerModels';
import type { Nullable } from '@virtuslab/nfs-shared/src/services/object';

import { toTree } from '..';

const queryResolver = (drawers: FlatDrawers, variables: DrawerQueryVariables): Nullable<Drawer> => {
  const drawerIndex = findIndex(drawers, { id: variables.id });

  if (drawerIndex === -1) {
    return null;
  }

  return toTree(drawers.slice(drawerIndex));
};

export default queryResolver;
